import moment from 'moment';

const subtractMonthsFromToday = (monthsQuantity: number) => {
  const date = new Date();
  date.setMonth(date.getMonth() - monthsQuantity);

  return moment(date).format();
};

export enum PeriodsEnum {
  OneMonth = 'OneMonth',
  ThreeMonths = 'ThreeMonths',
  SixMonths = 'SixMonths',
  TwelveMonths = 'TwelveMonths',
  Custom = 'custom',
  All = 'All',
}

const reportsPeriodsData = new Map([
  [PeriodsEnum.OneMonth, { label: '1 month', value: subtractMonthsFromToday(0) }],
  [PeriodsEnum.ThreeMonths, { label: '3 months', value: subtractMonthsFromToday(2) }],
  [PeriodsEnum.SixMonths, { label: '6 months', value: subtractMonthsFromToday(5) }],
  [PeriodsEnum.TwelveMonths, { label: '12 months', value: subtractMonthsFromToday(11) }],
  [PeriodsEnum.Custom, { label: 'Custom Period', value: PeriodsEnum.Custom }],
  [PeriodsEnum.All, { label: 'All', value: subtractMonthsFromToday(600) }],
]);

export const useReportPeriodsOptions = () => Array.from(reportsPeriodsData.values());
